import { ActionBase } from './actionBase';
const api = {
  state: {},
  actions: {
    // 新闻
    subForm(context, param) {
      return ActionBase.request(context, 'POST', context.rootState.url_1 + '/nbApplyInfo', param);
    },
    getNetbankArticle(context, param) {
      return ActionBase.request(context, 'GET', context.rootState.url_1 + '/nbArticle?', param);
    },
    getNetbankArticleDetail(context, param) {
      return ActionBase.request(context, 'GET', context.rootState.url_1 + '/nbArticle/findById?', param);
    },
    // 文档
    getCatalogWithDocsInfo(context, param) {
      return ActionBase.request(context, 'GET', context.rootState.url_1 + '/nbDirectory/getStructureDocInfo', param);
    },
    getTheDocById(context, param) {
      return ActionBase.request(context, 'GET', context.rootState.url_1 + '/nbDirectory?', param);
    },


  }
};
export default api;



// WEBPACK FOOTER //
// ./src/store/api.js